// core components/views
import ForgotPassword from "views/Account/ForgotPassword.jsx";
import LoginPage from "views/Account/Login.jsx";
import LogoutPage from "views/Account/Logout.jsx";
import Register from "views/Account/Register.jsx";
import UpdatePassword from "views/Account/UpdatePassword.jsx";
import ResetPassword from "views/Account/ResetPassword.jsx";
import { gisRoutes } from './routes';
import phrasebookLoad from "../i18n";
const phrasebook = phrasebookLoad()

/**
 * @path available paths on the account page(before authorisation)
 * @component main page that links to the path (available in views folder)
 * @routeType route type is to check whether the routes is coming from account or portal
 */
const accountRoutes = [
  {
    path: gisRoutes.account.login,
    navbarName: phrasebook.login_view.login,
    component: LoginPage,
    routeType: 'account'
  },
  {
    path: gisRoutes.account.forgot_password,
    navbarName: phrasebook.login_view.forgot_password,
    component: ForgotPassword,
    routeType: 'account'
  },
  {
    path: gisRoutes.account.logout,
    sidebarName: phrasebook.login_view.logout,
    navbarName: phrasebook.login_view.logout,
    component: LogoutPage,
    routeType: 'account'
  },
  {
    path: gisRoutes.account.register,
    navbarName: phrasebook.login_view.register,
    component: Register,
    routeType: 'account'
  },
  {
    path: gisRoutes.account.update_password,
    navbarName: phrasebook.profile.update_password,
    component: UpdatePassword,
    routeType: 'account'
  },
  {
    path: gisRoutes.account.reset_password,
    navbarName: phrasebook.profile.reset_password,
    component: ResetPassword,
    routeType: 'account'
  },
  // { redirect: true, path: "/", to: gisRoutes.account.login, navbarName: phrasebook.common.account, routeType: 'account' }
];

export default accountRoutes;
